var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Twitter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 381,
    height: 381,
    viewBox: "0 0 381 381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16752",
    "data-name": "Ellipse 16752",
    cx: 190.5,
    cy: 190.5,
    r: 190.5,
    fill: "#4ba0eb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_269858",
    "data-name": "Group 269858",
    transform: "translate(89.999 92.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497478",
    "data-name": "Path 497478",
    d: "M175.306,25.882l-18.461,3.077,12.308-15.384-21.538,6.154C119.922-11.041,76.845,22.8,89.153,50.5c-49.23,0-73.845-36.923-73.845-36.923S-3.154,41.266,27.615,62.8L9.154,56.651C9.154,75.112,21.461,87.42,43,93.573H21.461c12.308,24.615,33.846,24.615,33.846,24.615S36.846,133.573,3,133.573C104.537,182.8,166.075,90.5,156.844,41.266Z",
    transform: "translate(9.308 23.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497479",
    "data-name": "Path 497479",
    d: "M0,0H196.921V196.921H0Z",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter1);
export default __webpack_public_path__ + "static/media/Twitter1.0020832373ef1ce468545bc5ab0948e4.svg";
export { ForwardRef as ReactComponent };